export default __webpack_public_path__ + "static/33F324_A_0-fc324fa716c095762f84790fc4f33f83.woff2";